export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13696.d25e6911.jpg";